"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactJoyride = _interopRequireDefault(require("react-joyride"));
var _LoadingPage = require("react-platform-components/dist/components/LoadingPage");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _hooks = require("./hooks");
var _TopChips = require("./components/TopChips");
var _TopButtons = require("./components/TopButtons");
var _MainInfo = require("./components/MainInfo");
var _ProductInfo = require("./components/ProductInfo");
var _Image = require("./components/Image");
var _ImageButtons = require("./components/ImageButtons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reservationTourStep;
try {
  reservationTourStep = require("react-platform-reservation/dist/Reservation/index").reservationTourStep;
} catch (error) {}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _actionsBar;
  return {
    card: {
      "&:hover .actions-bar": {
        opacity: 1
      }
    },
    actionsBar: (_actionsBar = {
      opacity: 0
    }, _defineProperty(_actionsBar, theme.breakpoints.down("md"), {
      opacity: 1
    }), _defineProperty(_actionsBar, "background", "linear-gradient(to top, rgb(0 0 0 / 50%) 0%, rgb(0 0 0 / 20%) 40%, rgba(0,0,0,0) 100%)"), _defineProperty(_actionsBar, "transition", "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"), _actionsBar)
  };
});
var ProductSalableList = function ProductSalableList(props) {
  var _props$extraProps, _props$extraProps2, _props$extraProps3, _props$extraProps4, _props$extraProps5, _props$extraProps6;
  var products = props.products,
    inProgress = props.inProgress;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTour = _useState2[0],
    setShowTour = _useState2[1];
  var classes = useStyles();
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProduct = _useState4[0],
    setSelectedProduct = _useState4[1];
  var _useToggle = (0, _hooks.useToggle)(),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    isDrawerOpen = _useToggle2[0],
    toggleDrawer = _useToggle2[1];
  (0, _react.useEffect)(function () {
    if (products.length === 1 && localStorage.getItem("product-tour-showed") === null) {
      localStorage.setItem("product-tour-showed", true);
      setShowTour(true);
    }
  }, [products]);
  var handleProductSelect = function handleProductSelect(product) {
    return function () {
      toggleDrawer();
      setSelectedProduct(product);
    };
  };
  if (inProgress) {
    return /*#__PURE__*/_react.default.createElement(_LoadingPage.LoadingPage, {
      loadingText: "Obtenir vos produits, veuillez patienter..."
    });
  }
  var TopChips = ((_props$extraProps = props.extraProps) === null || _props$extraProps === void 0 ? void 0 : _props$extraProps.topChipsComponent) || _TopChips.TopChips;
  var TopButtons = ((_props$extraProps2 = props.extraProps) === null || _props$extraProps2 === void 0 ? void 0 : _props$extraProps2.topButtonsComponent) || _TopButtons.TopButtons;
  var MainInfo = ((_props$extraProps3 = props.extraProps) === null || _props$extraProps3 === void 0 ? void 0 : _props$extraProps3.mainInfoComponent) || _MainInfo.MainInfo;
  var Image = ((_props$extraProps4 = props.extraProps) === null || _props$extraProps4 === void 0 ? void 0 : _props$extraProps4.imageComponent) || _Image.Image;
  var ImageButtons = ((_props$extraProps5 = props.extraProps) === null || _props$extraProps5 === void 0 ? void 0 : _props$extraProps5.imageButtonsComponent) || _ImageButtons.ImageButtons;
  var ProductInfo = ((_props$extraProps6 = props.extraProps) === null || _props$extraProps6 === void 0 ? void 0 : _props$extraProps6.productInfoComponent) || _ProductInfo.ProductInfo;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    m: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_reactJoyride.default, {
    run: showTour,
    scrollToFirstStep: true,
    hideCloseButton: true,
    locale: {
      close: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
        id: "Close",
        defaultMessage: "Close"
      })
    },
    steps: _toConsumableArray(reservationTourStep ? [reservationTourStep] : [])
  }), products.map(function (product) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: product.id,
      item: true,
      xs: 12,
      sm: 6,
      lg: 4,
      xl: 3
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: classes.card,
      component: _core.Paper,
      elevation: 0,
      boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px"
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      position: "relative",
      padding: 1,
      paddingBottom: 0
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      position: "absolute",
      top: 16,
      right: 16,
      zIndex: 9
    }, /*#__PURE__*/_react.default.createElement(TopChips, {
      product: product
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      position: "absolute",
      top: 16,
      left: 16,
      zIndex: 9
    }, /*#__PURE__*/_react.default.createElement(TopButtons, {
      product: product
    })), /*#__PURE__*/_react.default.createElement(Image, {
      product: product
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: (0, _clsx.default)(classes.actionsBar, "actions-bar"),
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      height: 68,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(ImageButtons, _extends({
      product: product
    }, props))))), /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: "cursor-pointer",
      padding: 2,
      paddingTop: 0,
      display: "flex",
      flexDirection: "column",
      onClick: handleProductSelect(product)
    }, /*#__PURE__*/_react.default.createElement(MainInfo, {
      product: product
    }))));
  })), /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    anchor: "right",
    open: isDrawerOpen,
    onClose: toggleDrawer,
    BackdropProps: {
      invisible: true
    }
  }, /*#__PURE__*/_react.default.createElement(ProductInfo, _extends({}, props, {
    product: selectedProduct,
    onClose: toggleDrawer
  }))));
};
var _default = ProductSalableList;
exports.default = _default;